// Module
var code = `<template class="\${hideHeader ? 'hide-header' : ''}">
    <input class.bind="cssClass" class="dynamik-input__input" placeholder.bind="placeholder" value.two-way="dateValue">
    <label class="dynamik-input__label">\${placeholder}</label>
    <span></span>
</template>`;
// Exports
export default code;